import { useContext, useEffect, useState } from "react";

import { AuthAppContext } from "components/root/auth-app-provider";
import { CONFIG } from "config";
import { authHeaders, handleUnauthorized, logException } from "utils";
import {
  type KeystoneInspection,
  type KeystoneInspections,
} from "utils/keystone-api-mapping";

export const useInspectionsData = () => {
  const { selectedPolicyId } = useContext(AuthAppContext);
  const [loading, setLoading] = useState(true);
  const [inspectionsData, setInspectionsData] = useState<KeystoneInspections>();
  const [latestInspection, setLatestInspection] =
    useState<KeystoneInspection>();
  const inspectionDeadline = inspectionsData?.inspectionDeadline;

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const endpoint = `${CONFIG.KEYSTONE_PROXY_HREF}/api/inspections/${selectedPolicyId}`;
        const res = await fetch(endpoint, {
          headers: authHeaders({
            Accept: "application/json",
            "content-type": "application/json",
          }),
          credentials: "include",
        });
        if (res.ok) {
          const inspectionsData = await res.json();
          setInspectionsData(inspectionsData);
        } else {
          if ([401, 403].includes(res.status)) {
            handleUnauthorized({ endpoint });
          }
        }
      } catch (err) {
        logException(err);
      }
      setLoading(false);
    })();
  }, [selectedPolicyId]);

  // Use latest inspection:
  useEffect(() => {
    if (inspectionsData?.inspections) {
      const latest = inspectionsData?.inspections.sort(
        (a, b) =>
          new Date(b.createdTimestamp).getTime() -
          new Date(a.createdTimestamp).getTime()
      )[0];

      if (latest) {
        setLatestInspection(latest);
      }
    }
  }, [inspectionsData?.inspections]);

  return { loading, latestInspection, inspectionDeadline };
};
